/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { useCallback, useMemo, useState, type JSX } from 'react';
import { useTranslation } from 'react-i18next';

import {
  type TimesheetPeriod,
  TimesheetView,
  rangeFor,
} from '../../components/timesheet/timesheet-view.js';
import { PageHeader } from '../../components/ui/page-header.js';
import { useMyTimesheet } from '../../lib/queries/timesheet.js';

/** Therapist portal → Timesheet (BRD v2.0 CR-002): own session-based timesheet. */
export function TherapistTimesheetPage(): JSX.Element {
  const { t } = useTranslation();
  const [period, setPeriod] = useState<TimesheetPeriod>('this_month');
  const range = useMemo(() => rangeFor(period), [period]);
  const query = useMyTimesheet(range);
  const onPeriod = useCallback((p: TimesheetPeriod) => {
    setPeriod(p);
  }, []);

  return (
    <div className="p-8">
      <PageHeader title={t('timesheet.title')} subtitle={t('timesheet.subtitle')} />
      <TimesheetView
        data={query.data}
        isLoading={query.isLoading}
        isError={query.isError}
        period={period}
        onPeriod={onPeriod}
      />
    </div>
  );
}
